module.exports = new __parcel__URL__("business-board-empty-state.86be8cfc.svg").toString();